export { sharedConfig } from '@framework/tenant/config/dataroom';
